RivalIQ.apps.SocialPosts.module('views', function (views, App, Backbone, Marionette, $, _, s) {
    'use strict';

    function isNonDefaultSelected(prop, defaultValue) {
        return prop && prop !== defaultValue;
    }

    const SortDropdown = views.SortDropdown = Marionette.ItemView.mixin({
        attributes: {
            style: 'width: 100%'
        },

        template: '#socialPostsSortDropdownTemplate',

        behaviors: {
            DropdownSelector: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        ui: {
            sortOrderBtn: '.x-sort-order'
        },

        events: {
            'click @ui.sortOrderBtn': 'onSetSortOrder'
        },

        defaultSelector: function () {
            const me = this;

            let index = 0;

            const definition = App.utils.getOrderBy(me);
            if (definition) {
                const metrics = me.getMetrics();
                for (let temp, i = 0; i < metrics.length; i++) {
                    temp = metrics[i].toType();
                    if (RivalIQ.metric.equal(definition, temp)) {
                        index = i;
                        break;
                    }
                }
            }

            return `[data-item-id=${index}]`;
        },

        getMetrics: function () {
            const me = this;

            const metric = me.dashboardModel.metric;

            const isTopBottomLayout = App.utils.isTopBottomLayout(me);
            // remove non-numerical values and Followers in the top bottom layout dropdown
            const metricOptions = isTopBottomLayout ? {
                categories: ['post_analysis'],
                omitProperties: ['presence_reach']
            } : {};
            const childMetrics = metric.getChildMetrics(metricOptions).reject(function (metric) {
                return (_.result(metric.attributes, ['selectable']) === false);
            });

            const reduceBase = isTopBottomLayout ? [] : [
                new RivalIQ.models.MetricDefinition({
                    channel: me.getProp('channel'),
                    dimensions: ['post'],
                    property: 'published_at'
                })
            ];
            const metrics = _.reduce(childMetrics, function (memo, childMetric) {
                let metrics = [
                    childMetric
                ];

                const submetrics = childMetric.get('submetrics');

                if (submetrics) {
                    metrics = submetrics.reduce(function (memo, submetric) {
                        if (!submetric.get('omit')) {
                            return memo.concat(submetric);
                        }
                        return memo;
                    }, metrics);
                }

                return memo.concat(metrics);
            }, reduceBase);

            return metrics;
        },

        getGroups: function (selectableItems) {
            return [
                {
                    id: 0,
                    name: '',
                    selectableItems: selectableItems
                }
            ];
        },

        serializeData: function () {
            const me = this;

            const metrics = me.getMetrics();
            const selectableItems = _.map(metrics, function (metric, i) {
                return {
                    id: i,
                    _metric: metric,
                    name: metric.getName(),
                    property: metric.get('property')
                };
            });

            const groups = me.getGroups(_.sortBy(selectableItems, 'name'));

            let sortOrder = me.getProp('sortOrder');
            if (!_.isFinite(sortOrder)) {
                sortOrder = 1;
            }

            const additionalClasses = groups.length > 1 ? 'insights-dropdown-menu' : '';

            return {
                label: 'Sort',
                groups: groups,
                additionalClasses: additionalClasses,
                sortAsc: (sortOrder === -1)
            };
        },

        onRender: function () {
            const me = this;

            if (App.utils.isTopBottomLayout(me)) {
                me.ui.sortOrderBtn.hide();
            }
        },

        onSelectDropdown: function (data) {
            const me = this;

            const metrics = me.getMetrics();
            const metric = metrics[data.itemId];

            me.setProps({
                orderBy: metric.toType()
            });
        },

        onSetSortOrder: function (e) {
            const me = this;

            const sortOrder = e.target.getAttribute('data-sort-order');

            me.setProps({
                sortOrder: Number(sortOrder)
            });
        }
    });

    views.PostLayoutDropdown = Marionette.ItemView.mixin({
        attributes: {
            style: 'width: 100%'
        },

        template: '#adNavToolbarSelectorTemplate',

        behaviors: {
            DropdownSelector: {
                prop: 'layout',
                propDefaultValue: 'list'
            }
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        serializeData: function () {
            const me = this;
            const selectableItems = [
                {
                    id: 'list',
                    name: 'List'
                },
                {
                    id: 'grid_square',
                    name: 'Grid'
                },
                {
                    id: 'grid_square_with_details',
                    name: 'Grid with Details',
                    template: function (item) {
                        return $.tagHtml('li', {
                            html: $.tagHtml('a', {
                                'data-item-id': item.id,
                                class: ['x-select-item', 'pointer'],
                                html: [
                                    'Grid&nbsp;',
                                    $.tagHtml('span', {
                                        class: ['hidden-md', 'hidden-sm'],
                                        html: 'with&nbsp;'
                                    }),
                                    $.tagHtml('span', {
                                        class: [
                                            'visible-md-inline',
                                            'visible-sm-inline'
                                        ],
                                        text: '('
                                    }),
                                    'Details',
                                    $.tagHtml('span', {
                                        class: [
                                            'visible-md-inline',
                                            'visible-sm-inline'
                                        ],
                                        text: ')'
                                    })
                                ].join('')
                            })
                        });
                    }
                },
                {
                    id: 'grid',
                    name: 'Mosaic'
                },
                {
                    id: 'grid_with_details',
                    name: 'Mosaic with Details',
                    template: function (item) {
                        return $.tagHtml('li', {
                            html: $.tagHtml('a', {
                                'data-item-id': item.id,
                                class: ['x-select-item', 'pointer'],
                                html: [
                                    'Mosaic&nbsp;',
                                    $.tagHtml('span', {
                                        class: ['hidden-md', 'hidden-sm'],
                                        html: 'with&nbsp;'
                                    }),
                                    $.tagHtml('span', {
                                        class: [
                                            'visible-md-inline',
                                            'visible-sm-inline'
                                        ],
                                        text: '('
                                    }),
                                    'Details',
                                    $.tagHtml('span', {
                                        class: [
                                            'visible-md-inline',
                                            'visible-sm-inline'
                                        ],
                                        text: ')'
                                    })
                                ].join('')
                            })
                        });
                    }
                }
            ];

            if (App.utils.canUseTopBottomGrids(me.dashboardModel.getCuration().id)) {
                selectableItems.push({
                    id: 'top_bottom_posts',
                    name: 'Top vs. Bottom'
                },
                {
                    id: 'top_bottom_posts_with_details',
                    name: 'Top vs. Bottom with Details',
                    template: function (item) {
                        return $.tagHtml('li', {
                            html: $.tagHtml('a', {
                                'data-item-id': item.id,
                                class: ['x-select-item', 'pointer'],
                                html: [
                                    'Top vs. Bottom&nbsp;',
                                    $.tagHtml('span', {
                                        class: ['hidden-md', 'hidden-sm'],
                                        html: 'with&nbsp;'
                                    }),
                                    $.tagHtml('span', {
                                        class: [
                                            'visible-md-inline',
                                            'visible-sm-inline'
                                        ],
                                        text: '('
                                    }),
                                    'Details',
                                    $.tagHtml('span', {
                                        class: [
                                            'visible-md-inline',
                                            'visible-sm-inline'
                                        ],
                                        text: ')'
                                    })
                                ].join('')
                            })
                        });
                    }
                });
            }

            return {
                label: 'Layout',
                selectableItems: selectableItems
            };
        },

        onSelectDropdown: function (data) {
            const me = this;
            _.defer(function () {
                me.setProps('layout', data.itemId);
            });
        }
    });


    views.TweetTypeMultiSelect = RivalIQ.apps.Dashboard.views.MultiSelectDropdown.mixin({
        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        getLabelName: _.constant('Tweet Type'),

        tweetTypeFilterPropName: 'tweetType',

        applyDropdownState: function () {
            const me = this;

            const selectedTweetTypeIds = me.getCheckboxesState().sort();
            if (_.isEqual(selectedTweetTypeIds, [RivalIQ.enums.tweetTypes.normal.id])) {
                me.setProps(me.tweetTypeFilterPropName, undefined);
            } else {
                me.setProps(me.tweetTypeFilterPropName, selectedTweetTypeIds.join(','));
            }
        },

        isHighlighted: function () {
            const me = this;

            const selectedTweetTypes = me._getSelectedTweetTypes();
            return !(_.size(selectedTweetTypes) === 1 && selectedTweetTypes[RivalIQ.enums.tweetTypes.normal.id]);
        },

        onCheckboxChange: function () {
            const me = this;

            const checked = me.getCheckboxesState();

            me.ui.controlButtons.toggleClass('hidden', !me._isCheckboxStateChanged() || _.isEmpty(checked));
        },

        getSelectionSummary: function (selectableItems) {
            const me = this;

            const selectedTweetTypes = me._getSelectedTweetTypes();

            const selectedNames = _(selectableItems)
                .filter(function (item) {
                    return selectedTweetTypes[item.id];
                })
                .map(function (item) {
                    return _.upperFirst(_.find(RivalIQ.enums.tweetTypes, {
                        id: item.id
                    }).name);
                })
                .value();

            let str;
            if (selectedNames.length === 2) {
                str = selectedNames.join(' and ');
            } else {
                str = selectedNames.join(', ');
            }

            return str;
        },

        _getSelectedTweetTypes: function () {
            const me = this;

            let tweetType = me.getProp(me.tweetTypeFilterPropName);
            let selectedTweetTypes;

            if (!tweetType) {
                selectedTweetTypes = [RivalIQ.enums.tweetTypes.normal.id];
            } else {
                if (!_.isString(tweetType)) {
                    tweetType = tweetType.toString();
                }
                selectedTweetTypes = tweetType.split(',');
            }

            return _.keyBy(selectedTweetTypes);
        },

        getSelectableItems: function () {
            const me = this;

            const itemNames = [
                RivalIQ.enums.tweetTypes.normal.name,
                RivalIQ.enums.tweetTypes.reply.name,
                RivalIQ.enums.tweetTypes.retweet.name
            ];

            const selectedTweetTypes = me._getSelectedTweetTypes();

            const byTweetTypeCounts = me.getOption('byTweetTypeCounts') || {};
            return _.map(itemNames, function (itemName) {
                const tweetType = RivalIQ.enums.tweetTypes[itemName];

                let html = $.tagHtml('span', {
                    class: ['tag-name'],
                    text: _.upperFirst(tweetType.name)
                });

                const count = byTweetTypeCounts[tweetType.id] || 0;
                html += $.tagHtml('span', {
                    class: ['text-muted'],
                    html: `(${count})`
                });

                return {
                    id: tweetType.id,
                    labelName: html,
                    selected: selectedTweetTypes[tweetType.id]
                };
            });
        }
    });

    const TypeDropdown = Marionette.ItemView.mixin({
        attributes: {
            style: 'width: 100%'
        },

        template: '#adNavToolbarSelectorTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        behaviors: {
            DropdownSelector: {
                prop: 'type',
                propDefaultValue: '',
                missingContentHtml: function () {
                    const me = this;
                    const propValue = me.view.getProp(me.options.prop);
                    return [s.capitalize(propValue), '(0)'].join(' ');
                }
            }
        },

        itemTemplate: function (item) {
            return $.tagHtml('li', {
                html: $.tagHtml('a', {
                    'data-item-id': item.id,
                    class: ['x-select-item', 'pointer'],
                    html: [
                        $.tagHtml('span', {
                            text: item.name
                        }),
                        $.tagHtml('span', {
                            class: 'text-muted',
                            text: ['(', item.count, ')'].join('')
                        })
                    ].join('&nbsp;')
                })
            });
        },

        serializeData: function () {
            const me = this;

            const data = me.getOption('data');
            const selectableItems = _.map(data, function (datum) {
                return {
                    id: datum[1],
                    name: datum[0],
                    count: datum[2],
                    template: me.itemTemplate
                };
            });

            return {
                label: 'Post Type',
                selectableItems: selectableItems,
                highlighted: isNonDefaultSelected(me.getProp('type'), '')
            };
        },

        onSelectDropdown: function (data) {
            const me = this;

            let type = data.itemId;
            if (type === '') {
                type = undefined;
            }

            me.setProps('type', type);
        }
    });

    const ChannelDropdown = views.ChannelDropdown = Marionette.ItemView.mixin({
        attributes: {
            style: 'width: 100%'
        },

        className: 'social-post-channel-dropdown',

        template: '#adNavToolbarSelectorTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        behaviors: {
            DropdownSelector: {
                prop: 'channel',
                propDefaultValue: RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.CROSS_CHANNEL].channel
            }
        },

        itemTemplate: function (item) {
            return $.tagHtml('li', {
                html: $.tagHtml('a', {
                    class: ['x-select-item', 'pointer'],
                    'data-item-id': item.id,
                    html: [
                        $.tagHtml('i', {
                            class: [
                                'fa',
                                'fa-fw',
                                item.icon,
                                'visible-md',
                                'visible-sm',
                                'channel-icon'
                            ]
                        }),
                        $.tagHtml('span', {
                            class: ['hidden-md', 'hidden-sm', 'channel-name'],
                            text: item.name
                        })
                    ].join('')
                })
            });
        },

        serializeData: function () {
            const me = this;
            const selectableItems = me.options.channels.map(function (channel) {
                return {
                    icon: channel.get('fontIcon'),
                    id: channel.get('channel'),
                    name: channel.get('name'),
                    template: me.itemTemplate
                };
            });

            return {
                label: $.tagHtml('span', {
                    class: ['hidden-md', 'hidden-sm'],
                    text: 'Channel'
                }),
                selectableItems: selectableItems,
                highlighted: isNonDefaultSelected(me.getProp('channel'), '')
            };
        },

        onSelectDropdown: function (data) {
            const me = this;

            const oldChannel = RivalIQ.data.channels.get(me.getProp('channel'));

            // NOTE when the channel is changed we need to remove any special
            // properties that only apply for this channel
            const props = _.reduce(oldChannel.get('socialPostsProps'), function (memo, prop) {
                return _.extend(memo, _.set({}, prop, undefined));
            }, {});

            const newChannel = RivalIQ.data.channels.get(data.itemId);

            let channel;
            if (!newChannel.isCrossChannel()) {
                channel = newChannel.get('channel');
            }
            props.channel = channel;

            // Normally we'd do a setProps here, but we want to force the configuration to be reloaded but we don't want
            // the posts widget to reload due to the props propagation before the configuration change (if it does, it'll
            // have metrics pointing at the old channel)
            Backbone.history.navigate(me.dashboardModel.getPath(props), {
                trigger: true
            });
        }
    });

    const PromotedPostDropdown = Marionette.ItemView.mixin({
        // NOTE this class name MUST EXIST or the Facebook Boosted Posts tour
        // will cease to work as designed (see #14225)
        className: 'promoted-post-dropdown',

        ui: {
            dropdown: '[data-toggle=dropdown]'
        },

        attributes: {
            style: 'width: 100%'
        },

        template: '#adNavToolbarSelectorTemplate',

        behaviors: {
            DropdownSelector: {
                prop: 'promotedPosts',
                propDefaultValue: RivalIQ.enums.likelyPromoted.filterTypes.include
            }
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        serializeData: function () {
            const me = this;

            const filterTypes = _.values(RivalIQ.enums.likelyPromoted.filterTypes);
            const serializableItems = _.map(filterTypes, function (filterType) {
                return {
                    id: filterType,
                    name: s.capitalize(filterType)
                };
            });

            return {
                label: 'Likely Boosted',
                selectableItems: serializableItems,
                highlighted: isNonDefaultSelected(me.getProp('promotedPosts'), 'include')
            };
        },

        templateHelpers: function () {
            return {
                description: RivalIQ.strings.likely_promoted_dropdown
            };
        },

        onBeforeShow: function () {
            const me = this;
            if (!RivalIQ.state.account.get('plan').has_likely_promoted) {
                me.ui.dropdown.prop('disabled', true);
                me.$el.popover({
                    html: true,
                    content: RivalIQ.strings.likely_promoted_dropdown_disabled,
                    trigger: 'hover',
                    container: 'body'
                });
            }
        },

        onSelectDropdown: function (data) {
            const me = this;

            const promotedPosts = data.itemId;
            me.setProps('promotedPosts', promotedPosts);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsSetBoostedPostFilter, {
                promotedPosts: promotedPosts
            });
        }
    });

    const SearchFieldNameDropdown = Marionette.ItemView.mixin({
        template: '#adNavToolbarSelectorTemplate',

        behaviors: {
            DropdownSelector: {}
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        defaultSelector: function () {
            const me = this;
            const selectedItem = me.model.get('fieldName') || 'searchTerm';
            return `[data-item-id="${selectedItem}"]`;
        },

        serializeData: function () {
            return {
                label: 'Search by',
                selectableItems: _.map(['searchTerm', 'canonicalUrlFilter'], function (fieldName) {
                    const field = RivalIQ.enums.searchFieldNames[fieldName];
                    return {
                        id: field.fieldName,
                        name: field.name
                    };
                }),
                highlighted: false
            };
        },

        onSelectDropdown: function (data) {
            const me = this;

            const fieldName = data.itemId.toString();
            me.model.set('fieldName', fieldName);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsSetSearchFieldName, {
                fieldName: fieldName,
                curationId: _.get(me.dashboardModel, ['curation', 'id'], me.dashboardModel.id)
            });
        }
    });

    const DomainModeFilterDropdown = Marionette.ItemView.mixin({
        template: '#adNavToolbarSelectorTemplate',

        className: 'domain-mode-dropdown',

        behaviors: {
            DropdownSelector: {
                prop: 'domainModeFilter',
                propDefaultValue: RivalIQ.enums.socialPostsDomainModeFilters.all.id,
                missingContentHtml: function () {
                    const me = this;
                    const propValue = me.view.getProp(me.options.prop);
                    return [RivalIQ.enums.socialPostsDomainModeFilters[propValue].name, '(0)'].join(' ');
                }
            }
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        itemTemplate: function (item) {
            return $.tagHtml('li', {
                html: $.tagHtml('a', {
                    'data-item-id': item.id,
                    class: ['x-select-item', 'pointer'],
                    html: [
                        $.tagHtml('span', {
                            text: item.name
                        }),
                        $.tagHtml('span', {
                            class: 'text-muted',
                            text: ['(', item.count, ')'].join('')
                        })
                    ].join('&nbsp;')
                })
            });
        },

        serializeData: function () {
            const me = this;

            const data = me.getOption('data');
            const selectableItems = _.map(data, function (item) {
                return {
                    id: item.id,
                    name: item.name,
                    count: item.count || 0,
                    template: me.itemTemplate
                };
            });

            return {
                label: 'URL Type',
                selectableItems: selectableItems,
                highlighted: isNonDefaultSelected(me.getProp('domainModeFilter'), 'all')
            };
        },

        onSelectDropdown: function (data) {
            const me = this;

            const domainModeFilter = data.itemId;
            me.setProps('domainModeFilter', domainModeFilter);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsSetDomainModeFilter, {
                domainModeFilter: domainModeFilter
            });
        }
    });

    const IncompleteDataWarning = views.IncompleteDataWarning = Marionette.ItemView.mixin({
        template: '#socialPostsIncompleteDataWarningTemplate',

        className: 'incomplete-data-warning',

        ui: {
            warning: '.x-incomplete-data-warning',
            warningTooltipAnchor: '.x-incomplete-data-warning > .fa-warning'
        },

        mixins: {
            props: Marionette.Dashboard.mixins.Props
        },

        serializeData: _.noop,

        onRender: function () {
            const me = this;

            const channel = me.getProp('channel');
            const companyData = me.getOption('companyData');
            const periodStart = me.getProp('timePeriod').mainPeriodStart;
            const companiesWithIncompleteData = App.utils.findCompaniesWithIncompleteData(companyData, channel, periodStart);
            const companyIdsInSet = companyData.getCompanyIdsByCompanySet(me.getProp('companySetDescriptor'));

            // show warning only when a tagged company has incomplete data
            const showWarning = _.some(companyIdsInSet, function (companyId) {
                return _.find(companiesWithIncompleteData, {
                    companyId: companyId
                });
            });

            if (!showWarning) {
                me.ui.warning.hide();
            } else {
                const completeDataAfter = _.maxBy(companiesWithIncompleteData, 'latestFetchDate').latestFetchDate;

                const popoverTemplate = _.template($('#socialPostsIncompleteDataWarningMessageTemplate').html());

                const incompleteCompanies = _.map(companiesWithIncompleteData, function (company) {
                    return RivalIQ.state.landscape.getCompanyById(Number(company.companyId)).get('name');
                });
                const content = popoverTemplate({
                    incompleteCompanies: incompleteCompanies,
                    completeDataAfter: RivalIQ.formatter.formats.date(completeDataAfter)
                });

                me.ui.warning.show();
                me.ui.warningTooltipAnchor.popover({
                    html: true,
                    content: content,
                    trigger: 'hover',
                    placement: 'auto right',
                    container: 'body'
                });
            }
        }
    });

    views.Search = RivalIQ.views.LayoutView.mixin({
        tagName: 'ul',

        className: 'list-inline list-flex',

        template: '#socialPostsSearchTemplate',

        mixins: {
            props: Marionette.Dashboard.mixins.Props,
            postTagsReload: App.mixins.PostTagsReload,
            companySetChangeReload: RivalIQ.apps.Shell.mixins.CompanySetChangeReload
        },

        ui: {
            searchInput: '.search-input-container input',
            searchBtn: '.x-search',
            searchTips: '.search-tips-link',
            searchResultsSummary: '.x-search-results-summary'
        },

        regions: {
            searchFieldSelector: '.search-field-name-selector',
            typeDropdown: '.x-type-dropdown',
            channelSpecificFilter: '.x-channel-specific-filter',
            domainModeFilter: '.x-domain-mode-filter',
            channelPicker: '.x-channel-picker',
            postLayout: '.x-post-layout',
            postSort: '.x-post-sort',
            incompleteDataWarning: '.x-search-incomplete-data',
            postTagsFilter: '.x-post-tags-filter'
        },

        events: {
            'keypress @ui.searchInput': 'onKeyDown',
            'click @ui.searchBtn': 'onSearch',
            'click .x-clear': 'clearSearch',
            'click .x-select-type': 'setType'
        },

        dashboardModelEvents: {
            'change': 'reload'
        },

        modelEvents: {
            'change:fieldName': 'onFieldNameChange'
        },

        shouldShowSearchFieldNameDropdown: true,
        showPostTagsDropdown: true,

        initialize: function () {
            const me = this;

            me.model = new Backbone.Model();
            me.model.set('fieldName', me._getActiveFieldName(), {
                silent: true
            });
            Marionette.bindEntityEvents(me, me.model, me.modelEvents);
        },

        onKeyDown: function (e) {
            const me = this;

            if (e.which === 13) {
                e.preventDefault();
                me.onSearch();
            }
        },

        getBaseDefinition: function () {
            const me = this;
            const props = me.getProps();

            const definition = new RivalIQ.models.MetricDefinition({
                concept: (props.domainsOnly ? RivalIQ.metrics.descriptions.SOCIAL_POSTS_POSTED_URLS.id : RivalIQ.metrics.descriptions.SOCIAL_POSTS.id)
            });
            App.utils.updateMetric(definition, props);

            return definition;
        },

        loadData: function () {
            const me = this;

            const props = me.getProps();

            me.definition = me.getBaseDefinition();

            const allTypesDef = me.definition.build({
                type: undefined
            });
            const byTypeDef = allTypesDef.build({
                dimensions: ['type']
            });
            const typeNameDef = byTypeDef.build({
                property: 'name'
            });
            const allDomainModesDef = me.definition.build({
                domainModeFilter: undefined
            });

            const fetches = [
                me.definition.fetch(),
                allTypesDef.fetch(),
                byTypeDef.fetch(),
                typeNameDef.fetch(),
                allDomainModesDef.fetch()
            ];

            if (me.showPostTagsDropdown) {
                const postTagIdsDef = new RivalIQ.models.MetricDefinition({
                    concept: RivalIQ.metrics.descriptions.SOCIAL_POSTS_POST_TAG_IDS.id,
                    dimensions: ['post_tag_id'],
                    property: 'count',
                    limit: -1
                });
                App.utils.updateMetric(postTagIdsDef, _.extend(props, {
                    postTagConjunction: 'OR',
                    postTagExclude: false,
                    limitPostTagIds: false
                }));
                delete postTagIdsDef.attributes.postTagIds;

                fetches.push(postTagIdsDef.fetch());
                fetches.push(RivalIQ.postTags.data.PostTags.fetch());
            }

            if (me.getProp('channel') === RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.TWITTER].channel) {
                fetches.push(me.definition.build({
                    // we need to ask for all the tweet types
                    tweetType: _.map(RivalIQ.enums.tweetTypes, 'id').join(','),
                    dimensions: ['tweetType']
                }).fetch());
            }

            const deferred = new $.Deferred();
            $.when.apply($, fetches)
                .done(function (metric, allTypes, byType, typeName, allDomainModes, postTagIds, postTags, byTweetType) {
                    me.metric = metric;
                    me.allTypes = allTypes;
                    me.byType = byType;
                    me.typeName = typeName;
                    me.allDomainModes = allDomainModes;
                    me.postTagIds = postTagIds;
                    me.postTags = postTags;

                    // Since we want all the tweet type values in this metric, we have to delete the tweet type attribute (otherwise
                    // we'd be asking for the count where tweetType is exactly '1,2,3').
                    if (byTweetType) {
                        delete byTweetType.attributes.tweetType;
                    }
                    me.byTweetType = byTweetType;
                    me.error = null;
                })
                // NOTE this failure handling is for Twitter Mentions
                .fail(function (xhr) {
                    me.error = xhr;
                })
                .always(deferred.resolve);
            return deferred;
        },

        onRenderLoaded: function () {
            const me = this;
            let controlCount = 1;

            if (!me.error) {
                me.showSearchFieldNameDropdown();
                me.showResultsSummary(me.metric);
                me.showTypeDropdown(me.allTypes, me.byType, me.typeName);
                me.showDomainModeFilterDropdown(me.allDomainModes);
                me.showPostTagsFilter();

                if (me.getProp('companyId') || me.dashboardModel.getCuration().id === RivalIQ.enums.curation.POSTTAGSMANAGER) {
                    me.showChannelPicker();
                    controlCount++;
                }

                if (me.getProp('channel') === RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.TWITTER].channel) {
                    me.showTweetTypeDropdown();
                    controlCount++;
                } else if (me.getProp('channel') === RivalIQ.enums.sourceDetails[RivalIQ.enums.sources.FACEBOOK].channel) {
                    me.showPromotedPostDropdown();
                    controlCount++;
                }

                // NOTE this will have the effect of increasing the size of the
                // search input, while simultaneously shrinking the other controls
                // that might be rendered (see #14016)
                if (controlCount < 4) {
                    me.ui.searchInput.parent().parent().css({
                        'flex-grow': 3
                    });
                }

                // NOTE this ridiculousness is required so that we don't apply
                // responsive styling (which will limit the max widths of these
                // dropdowns) when it isn't strictly needed (see #14200)
                me.$el.toggleClass('encumbered', (controlCount > 1));

                me.updateSearchForChannelRedaction();
                me.showIncompleteDataWarning();

                App.utils.setupSearchTipsPopover(me.dashboardModel.id, me.ui.searchTips);
            }
        },

        _getPlaceholder: function () {
            const me = this;

            let placeholder = 'Search Post Content';
            if (me.model.get('fieldName') !== 'searchTerm') {
                placeholder = 'http://';
            }

            return placeholder;
        },

        serializeData: function () {
            const me = this;

            const searchTermInputValue = me.getProp(me._getActiveFieldName());

            return _.defaults({}, me.dashboardModel.getProps(), {
                searchTermInputValue: searchTermInputValue,
                placeholder: me._getPlaceholder()
            });
        },

        _getActiveFieldName: function () {
            const me = this;

            let fieldName = _.find(_.keys(RivalIQ.enums.searchFieldNames), function (fieldName) {
                return !_.isEmpty((me.getProp(fieldName) || '').trim());
            }) || me.model.get('fieldName');

            if (!fieldName) {
                const curation = me.dashboardModel.curation || me.dashboardModel;
                fieldName = (curation.id === RivalIQ.enums.curation.POSTED_URLS ?
                    RivalIQ.enums.searchFieldNames.canonicalUrlFilter : RivalIQ.enums.searchFieldNames.searchTerm).fieldName;
            }

            return fieldName;
        },

        showSearchFieldNameDropdown: function () {
            const me = this;

            if (me.shouldShowSearchFieldNameDropdown) {

                me.model.set('fieldName', me._getActiveFieldName());

                me.searchFieldSelector.show(new SearchFieldNameDropdown({
                    model: me.model,
                    dashboardModel: me.dashboardModel
                }));
            }
        },

        updateSearchForChannelRedaction: function () {
            const me = this;

            const fieldName = me.model.get('fieldName');
            const isSearchTerm = (fieldName === RivalIQ.enums.searchFieldNames.searchTerm.fieldName);

            const channel = RivalIQ.data.channels.get(me.getProp('channel'));
            const redactedChannels = App.utils.getPostedUrlsRedactedChannels();
            const isRedactedChannel = _.includes(redactedChannels, channel.get('channel'));

            const isDisabled = !isSearchTerm && isRedactedChannel;
            me.ui.searchInput.prop('disabled', isDisabled);

            me.ui.searchInput.parent().popover('destroy');
            if (isDisabled) {
                me.ui.searchInput.parent().popover({
                    html: true,
                    content: RivalIQ.str('search_by_dropdown_url_disabled', channel.get('name')),
                    trigger: 'hover',
                    container: 'body'
                });
            }
        },

        onFieldNameChange: function () {
            const me = this;

            const updatedProps = _.reduce(_.keys(RivalIQ.enums.searchFieldNames), function (memo, fieldName) {
                memo[fieldName] = '';
                return memo;
            }, {});
            updatedProps[me.model.get('fieldName')] = me.getProp(me.model.get('fieldName')) || me.getProp(me.model.previous('fieldName')) || '';

            me.setProps(updatedProps);
            me.ui.searchInput.attr('placeholder', me._getPlaceholder());

            me.updateSearchForChannelRedaction();
        },

        onSearch: function () {
            const me = this;

            const searchTerm = me.ui.searchInput.val().trim();
            const fieldName = me.model.get('fieldName');
            me.setProps(fieldName, searchTerm);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsSetSearchTerm, {
                searchTerm: searchTerm,
                fieldName: fieldName
            });
        },

        clearSearch: function () {
            const me = this;

            const fieldName = me.model.get('fieldName');
            me.setProps(fieldName, '');
        },

        setType: function (e) {
            const me = this;

            const type = $(e.currentTarget).data('type');
            e.preventDefault();
            me.setProps('type', type || undefined);

            RivalIQ.execute('tracking:push:auth', RivalIQ.tracking.metric.SocialPostsSetTypeFilter, {
                type: (type || 'all')
            });
        },

        showPostSort: function () {
            const me = this;

            me.postSort.show(new SortDropdown({
                metric: me.definition,
                dashboardModel: me.getDashboardModel()
            }));
        },

        showTypeDropdown: function (fullCount, count, name) {
            const me = this;

            if (me.isDestroyed || !me.metric) {
                return;
            }

            const data = [['All Media', '', fullCount.getValue()]];
            _.each(_.zip(name.getValue(), count.getValue()), function (rows) {
                data.push([rows[0][1], rows[0][0], rows[1][1]]);
            });

            me.typeDropdown.show(new TypeDropdown({
                dashboardModel: me.dashboardModel,
                data: data
            }));
        },

        showDomainModeFilterDropdown: function (metric) {
            const me = this;

            const curation = me.dashboardModel.curation || me.dashboardModel;
            if (curation.id === RivalIQ.enums.curation.POSTED_URLS) {

                const data = _.zipWith([
                    RivalIQ.enums.socialPostsDomainModeFilters.all,
                    RivalIQ.enums.socialPostsDomainModeFilters.owned,
                    RivalIQ.enums.socialPostsDomainModeFilters.curated
                ], [
                    metric.getValue(),
                    metric.clone({
                        property: 'owned_post_count'
                    }).getValue(),
                    metric.clone({
                        property: 'curated_post_count'
                    }).getValue()
                ], function (modeFilter, postCount) {
                    return _.extend({
                        count: postCount
                    }, modeFilter);
                });

                me.domainModeFilter.show(new DomainModeFilterDropdown({
                    dashboardModel: me.dashboardModel,
                    data: data
                }));
            }
        },

        showPostTagsFilter: function () {
            const me = this;

            if (me.metric && me.showPostTagsDropdown) {
                me.postTagsFilter.show(new App.views.PostTagsFilter({
                    dashboardModel: me.dashboardModel,
                    postTagIds: me.postTagIds.getValue(),
                    postTagsById: _.keyBy(me.postTags, 'id')
                }));
            }
        },

        showTweetTypeDropdown: function () {
            const me = this;

            const byTweetTypeCounts = _.reduce(me.byTweetType.getValue({
                format: false
            }), function (memo, value) {
                memo[value[0]] = value[1];
                return memo;
            }, {});
            me.channelSpecificFilter.show(new RivalIQ.apps.SocialPosts.views.TweetTypeMultiSelect({
                dashboardModel: me.dashboardModel,
                byTweetTypeCounts: byTweetTypeCounts
            }));
        },

        showPromotedPostDropdown: function () {
            const me = this;

            me.channelSpecificFilter.show(new PromotedPostDropdown({
                dashboardModel: me.dashboardModel
            }));
        },

        showChannelPicker: function () {
            const me = this;

            me.channelPicker.show(new ChannelDropdown({
                dashboardModel: me.dashboardModel,
                channels: RivalIQ.data.channels.withSearch().notHidden()
            }));
        },

        showIncompleteDataWarning: function () {
            const me = this;

            if (me.isDestroyed) {
                return;
            }

            me.incompleteDataWarning.show(new IncompleteDataWarning({
                dashboardModel: me.dashboardModel,
                companyData: me.getOption('companyData')
            }));
        },

        showResultsSummary: function (metric) {
            const me = this;

            if (me.isDestroyed || !metric) {
                return;
            }

            if (metric.getValue({
                format: false
            }) === 0) {
                me.ui.searchResultsSummary.text('No Results Found');
            } else {
                const text = _.flatten([
                    'Analyzing',
                    metric.getValue(),
                    'matching',
                    `${me.getPostName()}s`,
                    (me.getProp('domainsOnly') ? ['with', 'URLs'] : [])
                ]);

                me.ui.searchResultsSummary.text(text.join(' '));
            }
        },

        getPostName: function () {
            const me = this;
            const channel = me.getProp('channel');
            const name = RivalIQ.data.channels.get(channel).get('postName') || 'post';
            return name;
        },

        // NOTE this method tries to account for the oddball curation that is
        // company social posts, wherein the `dashboardModel` is not the thing
        // we think it is
        getDashboardModel: function () {
            const me = this;

            let dashboardModel = me.dashboardModel;
            if (!dashboardModel.metric) {
                dashboardModel = dashboardModel.widgets.first();
                // NOTE we have to proxy change events to the curation
                // `dashboardModel` to drive the query props
                me.listenTo(dashboardModel, 'change', function (model) {
                    me.dashboardModel.setProps(model.changed);
                });
            }

            return dashboardModel;
        }
    });

}, window.s);
